import { Realtime } from 'ably/build/ably-commonjs/'

const ably = new Realtime(process.env.REACT_APP_ABLY_API_KEY)

export default ably
